<template>
    <section class="reflection">
        <header class="section-header">
            <h3 class="h3 strong">Great Work!</h3>
            <p>You have listed your role models and provided the positive character traits (AKA Strengths) you recognize
                within each of them. Below you will find a filtered list of those Strengths in which the duplicates have been
                removed.</p>
            <p>Now its time for reflection. It is said, <i>"When you point a finger, three point back at you"</i>. This
                is usually heard in the context of some negative trait, but it doesn't have to be. In this exercise, we have
                flipped the script and brought your attention to the positive in others. In doing so, we have also identified
                The Greatness Within yourself. The premise here is that
                <strong>we can not see in others what we do not have
                    within ourselves.</strong></p>
            <p></p>
            <div class="character-traits">
                <h4>The Greatness Within You!</h4>
                <ul class="traits">
                    <li v-for="trait in uniqueCharacterTraits">
                        <span>{{ trait }}</span>
                    </li>
                </ul>
            </div>
        </header>

        <div class="section-body ">
            <div class="grid grid-cols-1 md:grid-cols-2">
                <div class="prompts-wrapper">
                    <h4>Reflection Prompts</h4>
                    <ul>
                        <li v-for="reflectionPrompt in reflectionPrompts">{{ reflectionPrompt }}</li>
                    </ul>

                </div>

                <div class="reflection-wrapper">
                    <h4>Your Reflection</h4>
                    <textarea v-model="selfReflection"
                              placeholder="Your reflections will be included in your PDF download"></textarea>
                </div>
            </div>

            <div class="download-prompt">
                <p>Download a PDF with your Strengths, Your Reflection, and Reflection Prompts.</p>
                <pdfGenerator
                    :characterTraits="uniqueCharacterTraits"
                    :reflectionPrompts
                    :selfReflection
                >
                </pdfGenerator>
            </div>

        </div>



        <!-- Next Step -->
        <footer class="section-footer">
            <p>Return to previous steps to add additional Role Models and/or Character Traits</p>
            <div class="next-prev-step">
                <button class="button accent-1 hollow" @click="$parent.previousStep()">Prev Step</button>
            </div>
        </footer>
    </section>
</template>

<script>
import pdfGenerator from "./pdfGenerator.vue";

export default {
    components: {pdfGenerator},
    props:      {},
    data() {
        return {
            selfReflection:    "",
            pdfContent:        "",
            reflectionPrompts: [
                "When we refer to these as Strengths, and state that they are within you, that does not mean that it is a highly developed trait... but it is within you!  Which of the Strengths do you feel you currently embody, which do you feel are underdeveloped, which do you feel are latent (hidden and waiting for you to develop)",
                "Of the underdeveloped Strengths, which would you like to develop more? How would further developing these Strengths impact your life? What actions can you take to better develop these Strengths?",
                "Of the latent Strengths, when considering these hidden Strengths and your potential to develop and embody them, what is your self talk?",
                "Of the latent Strengths, which would you like to develop? How would developing these Strengths impact your life? What actions can you take to begin developing these Strengths?"
            ]
        };
    },
    mounted() {
        // console.log("Reflection.vue mounted");
    },
    computed: {
        characterTraits() {
            let roleModels = this.$parent.roleModels;
            let traits = [];
            for (let i = 0; i < roleModels.length; i++) {
                for (let j = 0; j < roleModels[i].traits.length; j++) {
                    // console.log(roleModels[i].traits[j]);
                    if (roleModels[i].traits[j]) {
                        traits.push(roleModels[i].traits[j]);
                    }

                }
            }
            return traits;
        },
        uniqueCharacterTraits() {
            let uniqueTraits = [];
            for (let i = 0; i < this.characterTraits.length; i++) {
                if (!uniqueTraits.includes(this.characterTraits[i])) {
                    uniqueTraits.push(this.characterTraits[i]);
                }
            }
            return uniqueTraits;
        }
    },
    methods:  {}
}
</script>
